import React from 'react';
import { branch, renderComponent } from 'recompose';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { I18n } from 'js/components/common/I18n';
import FadeInContainer from './../FadeInContainer';
import style from './index.scss';

export const EmptyState = () => {
    const t = usePortletTranslations();
    const title = t('emptyState.title');

    return (
        <FadeInContainer className={style.container}>
            <div className={style.image} />
            {title && <p className={style.title}>{title}</p>}
            {<p className={style.description}><I18n t={t} tKey="emptyState.description" /></p>}
        </FadeInContainer>
    );
};

export const withEmptyState = branch(
    ({ leaderboards, error }) => leaderboards && !leaderboards.length || error,
    renderComponent(EmptyState)
);
